import script from "./service_cmp.vue?vue&type=script&setup=true&lang=js"
export * from "./service_cmp.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__